import axios from 'axios';
import { initialize } from 'redux-form';

import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';

const API = `${consts.API_URL}/brinde`;

export const BRINDE_AGUARDANDO = 'BRINDE_AGUARDANDO';
export const BRINDE_ENTRADA_MODO = 'BRINDE_ENTRADA_MODO';
export const BRINDE_SAIDA_MODO = 'BRINDE_SAIDA_MODO';
export const BRINDE_ENTRADAS = 'BRINDE_ENTRADAS';
export const BRINDE_SAIDAS = 'BRINDE_SAIDAS';
export const BRINDE_ESTOQUE = 'BRINDE_ESTOQUE';
export const BRINDE_OPCOES = 'BRINDE_OPCOES';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString().trim();
    const possuiSeparadorMilhar =
        /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const textoNormalizado =
        texto.includes(',') || possuiSeparadorMilhar
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto;
    const resultado = Number(textoNormalizado);

    return Number.isFinite(resultado) ? resultado : null;
};

const dataHoraLocal = valor => {
    const data = valor ? new Date(valor) : new Date();

    if (Number.isNaN(data.getTime())) {
        return valor;
    }

    data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
    return data.toISOString().substring(0, 16);
};

const dataHoraUtc = valor => {
    if (!valor || /Z$/i.test(valor) || /[+-]\d{2}:\d{2}$/.test(valor)) {
        return valor;
    }

    const data = new Date(valor);
    return Number.isNaN(data.getTime()) ? valor : data.toISOString();
};

export const setAguardando = aguardando => ({
    type: BRINDE_AGUARDANDO,
    payload: aguardando
});

export const setModoEntrada = (modo, registro = {}) => ({
    type: BRINDE_ENTRADA_MODO,
    payload: { modo, registro }
});

export const setModoSaida = (modo, registro = {}) => ({
    type: BRINDE_SAIDA_MODO,
    payload: { modo, registro }
});

export function initEntrada(registro = {}) {
    const quantidade = registro.id
        ? Number(registro.quantidade)
        : 0;
    const valorUnitario = registro.id
        ? Number(registro.valor_unitario)
        : 0;

    return initialize('brindeEntradaForm', {
        ...registro,
        quantidade,
        valor_unitario: valorUnitario,
        datahora_entrada: dataHoraLocal(
            registro.datahora_entrada
        )
    });
}

export function initSaida(registro = {}) {
    const itens = registro.itens && registro.itens.length
        ? registro.itens.map(item => ({
            ...item,
            quantidade: Number(item.quantidade)
        }))
        : [{ id_produto: null, quantidade: 1 }];

    return initialize('brindeSaidaForm', {
        observacao: '',
        ...registro,
        itens,
        datahora_saida: dataHoraLocal(registro.datahora_saida)
    });
}

export function getOpcoes() {
    return async dispatch => {
        try {
            const resposta = await axios.get(`${API}/opcoes`);
            dispatch({
                type: BRINDE_OPCOES,
                payload: resposta.data
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

const carregar = (url, tipo) => async dispatch => {
    try {
        dispatch(setAguardando(true));
        const resposta = await axios.get(url);
        dispatch({ type: tipo, payload: resposta.data });
    } catch (erro) {
        setErroAPI(erro);
    } finally {
        dispatch(setAguardando(false));
    }
};

export const getEntradas = () =>
    carregar(`${API}/entrada`, BRINDE_ENTRADAS);

export const getSaidas = () =>
    carregar(`${API}/saida`, BRINDE_SAIDAS);

export const getEstoque = () =>
    carregar(`${API}/estoque`, BRINDE_ESTOQUE);

export function salvarEntrada(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = {
                ...registro,
                id_fornecedor: Number(registro.id_fornecedor) || null,
                id_produto: Number(registro.id_produto) || null,
                datahora_entrada: dataHoraUtc(
                    registro.datahora_entrada
                ),
                quantidade: numero(registro.quantidade),
                valor_unitario: numero(registro.valor_unitario)
            };

            if (dados.id) {
                await axios.put(`${API}/entrada`, dados);
            } else {
                await axios.post(`${API}/entrada`, dados);
            }

            setSuccess(
                dados.id
                    ? 'Entrada de brinde atualizada.'
                    : 'Entrada de brinde incluída.'
            );
            dispatch(getEntradas());
            dispatch(getOpcoes());
            dispatch(setModoEntrada('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirEntrada(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            await axios.delete(`${API}/entrada`, {
                params: { id: registro.id }
            });
            setSuccess('Entrada de brinde excluída.');
            dispatch(getEntradas());
            dispatch(getOpcoes());
            dispatch(setModoEntrada('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvarSaida(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = {
                ...registro,
                id_cliente: Number(registro.id_cliente) || null,
                id_usuario_representante:
                    Number(registro.id_usuario_representante) || null,
                datahora_saida: dataHoraUtc(registro.datahora_saida),
                itens: (registro.itens || []).map(item => ({
                    id_produto: Number(item.id_produto) || null,
                    quantidade: numero(item.quantidade)
                }))
            };

            if (dados.id) {
                await axios.put(`${API}/saida`, dados);
            } else {
                await axios.post(`${API}/saida`, dados);
            }

            setSuccess(
                dados.id
                    ? 'Saída de brindes atualizada.'
                    : 'Saída de brindes incluída.'
            );
            dispatch(getSaidas());
            dispatch(getOpcoes());
            dispatch(setModoSaida('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirSaida(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            await axios.delete(`${API}/saida`, {
                params: { id: registro.id }
            });
            setSuccess('Saída de brindes excluída.');
            dispatch(getSaidas());
            dispatch(getOpcoes());
            dispatch(setModoSaida('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
